import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MauticRoutingModule } from 'src/routes/mautic-routing.module';
import { StepOneMauticComponent } from 'src/components/step-one-mautic/step-one-mautic.component';
import { StepTwoMauticComponent } from 'src/components/step-two-mautic/step-two-mautic.component';
import { FinishMauticComponent } from 'src/components/finish-mautic/finish-mautic.component';
import { SendRecoveryPasswordMauticComponent } from 'src/components/send-recovery-password-mautic/send-recovery-password-mautic.component';
import { environment } from 'src/environments/environment';
import { StepCompanyBasicInfoMauticComponent } from 'src/components/step-company-basic-info-mautic/step-company-basic-info-mautic.component';
import { StepCompanyContactMauticComponent } from 'src/components/step-company-contact-mautic/step-company-contact-mautic.component';
import { StepThreeMauticComponent } from 'src/components/step-three-mautic/step-three-mautic.component';
import { StepFourMauticComponent } from 'src/components/step-four-mautic/step-four-mautic.component';
import { ProgressMauticComponent } from 'src/components/progress-mautic/progress-mautic.component';

@NgModule({
    imports: [
        CommonModule,
        MauticRoutingModule
    ],
    declarations: [
        StepOneMauticComponent,
        StepTwoMauticComponent,
        StepThreeMauticComponent,
        StepFourMauticComponent,
        FinishMauticComponent,
        SendRecoveryPasswordMauticComponent,
        StepCompanyBasicInfoMauticComponent,
        StepCompanyContactMauticComponent,
        ProgressMauticComponent
    ],
    providers: [
        {
            provide: 'FORM_API_URL',
            useValue: environment.formApiUrl
        },
    ]
})
export class MauticFormsModule {



}